import FavouritesInformation from './FavouritesInformation';
export default FavouritesInformation;
